export default "__VITE_ASSET__$x07CihM__"